<app-planting-site-placeholder *ngIf="!sitesPage?.length"></app-planting-site-placeholder>

<div class="row">
    <div class="col-md-6 col-xl-4" *ngFor="let site of sitesPage">
        <div class="planting-box" [routerLink]="['/plantingSite', site.id]">
            <div class="planting-img" style="background-position: center;"
                [class.no-img]="!site.headerPhoto?.thumbnailUrl" [appBackgroundUrl]="site.headerPhoto?.thumbnailUrl">
                <span class="year">{{site.plantingDate | date: 'yyyy'}}</span>
                <span class="country">{{site.country}}</span>
            </div>
            <div class="planting-detail">
                <h4>{{site.title}}</h4>
                <span class="city">{{site.region}}</span>
                <div class="tree-info">
                    <span>{{site.totalTrees | number}} trees</span>
                    <span *ngIf="site.availableTrees > 0; else notAvailable">Available:
                        {{site.availableTrees | number}}</span>
                    <ng-template #notAvailable><span class="text-danger">Fully sponsored</span></ng-template>
                </div>
            </div>
        </div>
    </div>

</div>

<div [class.d-none]="sites.length == 0">
    <div class="page-size-selector">
        <pagination [totalItems]="sites.length" [itemsPerPage]="pageSize" [directionLinks]="false"></pagination>
        <div class="page-length">
            <span>Items per page</span>
            <div class="btn-group" dropdown [dropup]="true">
                <button id="button-dropup" dropdownToggle type="button" class="btn dropdown-toggle" aria-controls="dropdown-dropup">
                    {{pageSize}}
                </button>
                <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                    aria-labelledby="button-dropup">
                    <li role="menuitem" *ngFor="let o of pageSizeSelectAbleOptions" (click)="onUpdatePageSize(o)">
                        <a class="dropdown-item">{{o}}</a>
                    </li>
                </ul>

            </div>
        </div>

    </div>
</div>
